<template>
    <div class="not-found-page-box">
        <p class="not-found-page-box__text">Хоба!</p>
        <img class="not-found-page-box__img" src="../assets/img/sad-cat.png" width="100px" alt="хоба-текст">
        <p class="not-found-page-box__text">Страница не найдена</p>
    </div>
</template>

<script>

export default {
    

    
}
</script>

<style lang="scss">
    .not-found-page-box{
        height: 100%;
        display: flex; 
        justify-content: center;
        align-items: center;
        &__text{
            font-size: 35px;
            color: $brand-clr-1;
        }
        &__img{
            margin: 0 20px;
        }
    }
</style>